export default {
  id: "timeSeriesGrossProfit",
  name: "",
  description: "",
  report: {
    name: "Daily Gross Profit",
    chartType: "LINE",
    template: "custom",
    config: {
      dataType: "time_series",
      dataSet: "SaleItem",
      dimensions: [],
      measures: ["SaleItem.gross_profit"],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: true,
      limit: "100",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
